var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePhonesMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 6H15C14.7239 6 14.5 6.22386 14.5 6.5V9.5H11.5C11.2239 9.5 11 9.72386 11 10V12C11 12.2761 11.2239 12.5 11.5 12.5H14.5V15.5C14.5 15.7761 14.7239 16 15 16H17C17.2761 16 17.5 15.7761 17.5 15.5V12.5H20.5C20.7761 12.5 21 12.2761 21 12V10C21 9.72386 20.7761 9.5 20.5 9.5H17.5V6.5C17.5 6.22386 17.2761 6 17 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5V19C3 20.6569 4.34315 22 6 22H14C15.6569 22 17 20.6569 17 19V17.5H15C13.8954 17.5 13 16.6046 13 15.5V14H11.5C10.3954 14 9.5 13.1046 9.5 12V10C9.5 8.89543 10.3954 8 11.5 8H13V6.5C13 5.39543 13.8954 4.5 15 4.5H16.9585C16.7205 3.08114 15.4865 2 14 2H6C4.34315 2 3 3.34315 3 5ZM6.25 19C6.25 18.5858 6.58579 18.25 7 18.25H13C13.4142 18.25 13.75 18.5858 13.75 19C13.75 19.4142 13.4142 19.75 13 19.75H7C6.58579 19.75 6.25 19.4142 6.25 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhonesMedical);
export default __webpack_public_path__ + "static/media/mobile-phones-medical.06c10c7d94ecd077726592c862e7cd53.svg";
export { ForwardRef as ReactComponent };